import { ArrowLeft } from 'lucide-react'
import { useState } from 'react'

import { Button } from '@/ui-components/Button'
import { Field, Label } from '@/ui-components/Fieldset'
import { Heading } from '@/ui-components/Heading'
import { Input } from '@/ui-components/Input'
import AccountCapabilities from '@/views/GlobalAccountDetails/AccountCapabilities'
import type { AccountCapabilitiesData } from '@/views/GlobalAccountDetails/AccountCapabilities'
import CountrySelection from '@/views/NewGlobalAccount/CountrySelection'

export type GlobalAccountCurrency = {
  flag: string
  code: string
  name: string
  capabilities: AccountCapabilitiesData
}

const MOCK_GLOBAL_ACCOUNT_CAPABILITIES: AccountCapabilitiesData[] = [
  // mock 1
  {
    acceptFundsVia: [
      { method: 'Domestic Bank Transfer', daysToComplete: '0-1 days', active: true },
      { method: 'International SWIFT Transfer', daysToComplete: '1-2 days', active: false },
    ],
    payoutVia: [
      { method: 'BECS direct debit', active: true },
      { method: 'Wire payout', active: false },
    ],
  },
  // mock 2
  {
    acceptFundsVia: [
      { method: 'Domestic Bank Transfer', daysToComplete: '1-4 hours', active: true },
      { method: 'SWIFT Transfer', daysToComplete: '1-3 days', active: false },
      { method: 'Domestic Fedwire Transfer', daysToComplete: '30-40 minutes', active: true },
      { method: 'Credit Card', daysToComplete: '1-2 days', active: false },
    ],
    payoutVia: [
      { method: 'ACH Direct Debit', active: false },
      { method: 'iDeal Wire Transfer', active: true },
    ],
  },
]

const MOCK_GLOBAL_ACCOUNT_CURRENCIES: GlobalAccountCurrency[] = [
  {
    flag: '🇦🇺',
    code: 'AUD',
    name: 'Australia',
    capabilities: MOCK_GLOBAL_ACCOUNT_CAPABILITIES[0],
  },
  {
    flag: '🇨🇦',
    code: 'CAD',
    name: 'Canada',
    capabilities: MOCK_GLOBAL_ACCOUNT_CAPABILITIES[1],
  },
  {
    flag: '🇩🇰',
    code: 'DKK',
    name: 'Denmark',
    capabilities: MOCK_GLOBAL_ACCOUNT_CAPABILITIES[0],
  },
  {
    flag: '🇪🇪',
    code: 'EUR',
    name: 'Estonia',
    capabilities: MOCK_GLOBAL_ACCOUNT_CAPABILITIES[1],
  },
  {
    flag: '🇩🇪',
    code: 'EUR',
    name: 'Germany',
    capabilities: MOCK_GLOBAL_ACCOUNT_CAPABILITIES[0],
  },
  {
    flag: '🇭🇰',
    code: 'HKD',
    name: 'Hong Kong SAR',
    capabilities: MOCK_GLOBAL_ACCOUNT_CAPABILITIES[1],
  },
  {
    flag: '🇮🇩',
    code: 'IDR',
    name: 'Indonesia',
    capabilities: MOCK_GLOBAL_ACCOUNT_CAPABILITIES[0],
  },
  {
    flag: '🇲🇽',
    code: 'MXN',
    name: 'Mexico',
    capabilities: MOCK_GLOBAL_ACCOUNT_CAPABILITIES[1],
  },
  {
    flag: '🇳🇱',
    code: 'EUR',
    name: 'Netherlands',
    capabilities: MOCK_GLOBAL_ACCOUNT_CAPABILITIES[0],
  },
  {
    flag: '🇳🇿',
    code: 'NZD',
    name: 'New Zealand',
    capabilities: MOCK_GLOBAL_ACCOUNT_CAPABILITIES[1],
  },
  {
    flag: '🇵🇭',
    code: 'PHP',
    name: 'Philippines',
    capabilities: MOCK_GLOBAL_ACCOUNT_CAPABILITIES[0],
  },
  {
    flag: '🇸🇬',
    code: 'SGD',
    name: 'Singapore',
    capabilities: MOCK_GLOBAL_ACCOUNT_CAPABILITIES[1],
  },
  {
    flag: '🇦🇪',
    code: 'AED',
    name: 'United Arab Emirates',
    capabilities: MOCK_GLOBAL_ACCOUNT_CAPABILITIES[0],
  },
  {
    flag: '🇬🇧',
    code: 'GBP',
    name: 'United Kingdom',
    capabilities: MOCK_GLOBAL_ACCOUNT_CAPABILITIES[1],
  },
  {
    flag: '🇺🇸',
    code: 'USD',
    name: 'United States',
    capabilities: MOCK_GLOBAL_ACCOUNT_CAPABILITIES[0],
  },
]

const NewGlobalAccountPage: React.FC = () => {
  const [globalAccountNickname, setGlobalAccountNickname] = useState('')
  const [selectedGlobalAccount, setSelectedGlobalAccount] = useState(
    MOCK_GLOBAL_ACCOUNT_CURRENCIES[MOCK_GLOBAL_ACCOUNT_CURRENCIES.length - 1],
  )

  return (
    <>
      <div className="space-y-6">
        <Button
          plain
          to="/wallet"
        >
          <ArrowLeft data-slot="icon" />
          Back
        </Button>

        <Heading level={3}>New Global Account</Heading>

        <Field>
          <Label>Account Nickname</Label>
          <Input
            placeholder={`Nickname for ${selectedGlobalAccount.name}`}
            value={globalAccountNickname}
            onChange={(e) => setGlobalAccountNickname(e.target.value)}
          />
        </Field>

        <CountrySelection
          currencies={MOCK_GLOBAL_ACCOUNT_CURRENCIES}
          selectedCountry={selectedGlobalAccount.name}
          onSelect={setSelectedGlobalAccount}
        />

        <AccountCapabilities data={selectedGlobalAccount.capabilities} />
      </div>

      <div className="flex justify-end gap-x-2">
        <Button
          outline
          onClick={() => console.log('Cancel clicked!')}
        >
          Cancel
        </Button>
        <Button
          color="primary"
          onClick={() => console.log('Create Global Account clicked!')}
        >
          Create Global Account
        </Button>
      </div>
    </>
  )
}

export default NewGlobalAccountPage
